import React from "react";

export default function HealthTrend({ series, width = 96, height = 24 }) {
  const vals = (series || []).map(s => s.score);
  if (vals.length < 2) return <span className="text-[10px] text-slate-400 font-mono-plex" title="Trend appears after a few days of history" data-testid="health-trend-empty">trend soon</span>;
  const min = Math.min(...vals), max = Math.max(...vals);
  const span = Math.max(1, max - min);
  const step = width / (vals.length - 1);
  const y = (v) => height - 2 - ((v - min) / span) * (height - 4);
  const pts = vals.map((v, i) => `${i * step},${y(v)}`).join(" ");
  const delta = vals[vals.length - 1] - vals[0];
  const tone = delta > 0 ? "text-emerald-600" : delta < 0 ? "text-rose-600" : "text-slate-500";
  return (
    <div className="inline-flex items-center gap-1.5" title={`${series[0].date} → ${series[series.length - 1].date}: ${vals[0]} → ${vals[vals.length - 1]}`} data-testid="health-trend">
      <svg width={width} height={height} className="overflow-visible">
        <polyline points={pts} fill="none" stroke="currentColor" strokeWidth="1.5" className={tone} />
        <circle cx={(vals.length - 1) * step} cy={y(vals[vals.length - 1])} r="2.5" fill="currentColor" className={tone} />
      </svg>
      <span className={`text-[10px] font-mono-plex font-bold ${tone}`}>{delta > 0 ? "+" : ""}{delta}</span>
    </div>
  );
}
